<template>
    <div v-if="monthArr.length">
        <answer-header type="back"></answer-header>
        <img class="logo" src="../assets/logo.png">
        <div class="month-wrap">
            <div @click="_prev"><<</div>
            <div class="month">{{monthArr[curMonthIndex].show}}</div>
            <div @click="_next">>></div>
        </div>
        <div class="rank-mod">
            <table class="rank-table" v-infinite-scroll="_loadMore" infinite-scroll-distance="10" infinite-scroll-disabled="loading" infinite-scroll-immediate-check="true">
                <thead>
                    <tr>
                        <th>အဆင့္</th><th>အသံုးျပဳသူ ID</th><th>ရမွတ္</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in list">
                        <td><div class="num">{{index+1}}</div></td><td>{{item.nickname || item.mobile}}</td><td>{{item.score}}</td>
                    </tr>
                </tbody>
            </table>
            <!-- <div class="pull-down">
                <i class="iconfont qicon-down"></i>
            </div> -->
        </div>

        <div class="btn btn-block" @click="_goStore">ကၽြန္ပ္၏ Quest</div>
    </div>
</template>

<script>
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
import config from '../config'
const monthArr = []
export default {
    name: 'Rank',
    components: {answerHeader},
    data(){
        return {
            loading: false,
            page: 0,
            list: [],
            monthArr: [],
            curMonthIndex: null,
        }
    },
    computed: {
        ...mapState(['lang,langMap'])
    },
    watch: {
        curMonthIndex(cur, old){
            if(this.curMonthIndex == null) return;
            var date = this.monthArr[cur].f;
            if(cur != old){
                this.list = [];
            }
            this.page = 0;
            this.loading = true;
            this._fetchList(date).done(res=>{
                if(res.code != 0){
                    this.$toast(res.msg);
                }
                else if(res.data.list.length > 0){
                    this.list = this.list.concat(res.data.list);
                }else{
                    this.$toast('no data');
                }
            }).always(()=>{
                this.loading = false;
            });
        }
    },
    created(){
        this._fetchMonth();
    },
    methods: {
        _loadMore(){
            this.loading = true;
            this._fetchList(this.monthArr[this.curMonthIndex].f).done(res=>{
                if(res.code != 0){
                    this.$toast(res.msg);
                }
                else if(res.data.list.length > 0){
                    this.list = this.list.concat(res.data.list);
                }else{
                    this.$toast('no more');
                }
            }).always(()=>{
                this.loading = false;
            })
        },
        _fetchMonth(){
            Utils.$ajax({
                url: `rank/list`,
            }).done(res=>{
                this.monthArr = res.data;
                this.curMonthIndex = this.monthArr.length > 0 ? this.monthArr.length-1 : 0;
            })
        },
        _fetchList(date){
            this.page++;
            return Utils.$ajax({
                url: `/core/rank&page_id=${this.page}&page_size=10`,
                data: {ym: date}
            })
        },
        _goStore(){
            this.$router.push('/store')
        },
        _dateFormat(date){
            var year = date.getFullYear();
            var month = date.getMonth();

        },
        _prev(){
            if(this.curMonthIndex > 0){
                this.curMonthIndex--;
            }
        },
        _next(){
            if(this.curMonthIndex < this.monthArr.length-1){
                this.curMonthIndex++;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .month-wrap{
        display: flex;
        justify-content: space-around;
        color: #fff;
        font-size: rem(36);
        font-weight: bold;
    }
    .rank-mod{
        width: 100%;
        height: rem(780);
        overflow: scroll;
    }
    .pull-down{
        color: #fff;
        text-align: center;
        animation: pulldown 800ms infinite;
    }
    .rank-table{
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: rem(30);
        td, th{
            border-bottom: 1px rgba(255,255,255,.6) dashed;
            padding: .8em 0;
        }
        .num{
            width: rem(40);
            height: rem(40);
            border-radius: 50%;
            background: #c37600;
        }
    }
    @keyframes pulldown
    {
        from {transform: translateY(0);}
        to {transform: translateY(50%);}
    }
</style>


// WEBPACK FOOTER //
// src/components/Rank.vue